import { Factory } from '../../services/Factory';

namespace app.directives.auditing {
  export interface IAuditScope extends angular.IScope {
    iioAudit: { projectId: string, description: string, actionDetails }
  }

  export interface IAuditAttributes extends angular.IAttributes {
  }

  export class Audit implements angular.IDirective {
    public restrict = 'A';
    public scope = {iioAudit: '='};
    public link: (scope: IAuditScope, element: angular.IAugmentedJQuery, attrs: IAuditAttributes) => void;

    constructor(auditLogService: app.services.auditing.AuditLogService) {
      this.link = (scope: IAuditScope, element: angular.IAugmentedJQuery, attrs: IAuditAttributes) => {
        element.on("click", () => {
          auditLogService.Audit(scope.iioAudit.projectId, scope.iioAudit.description, scope.iioAudit.actionDetails);
        });
      };
    }
  }

  frontendApp.directive("iioAudit", ["AuditLogService", Factory.Create(Audit)]);
}
